import React, { useState, useRef, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { alert_error, alert_success } from "../../AppContext.js";
import { Cookies } from '../../index.js';
import axios from 'axios';
import { isLocalHost } from '../../shared/host_utils.js';

const TaskList = () => {
    const [data_home, set_data_home] = useState({
        links: [
            { to: "", text: "Please wait a moment 😊 ..." }
        ]
    });

    useEffect(() => {
        if (window.location.href.includes('memory')) {
            fetchData_1("https://hust.media/img/memory/get_folder.php");
        } else {
            fetchData_2("https://node_js.hust.media/main_2/users/admin/data_home");
        }
    }, []);
    const fetchData_1 = (value) => {
        axios.get(value, {
            // params: {
            //     id_orders: id_orders,
            //     username: username
            // }
        })
            .then((response) => {
                if (window.location.href.includes('memory')) {
                    set_data_home(response.data);
                } else {
                    set_data_home(response.data.api_results.mongo_results);
                }
            })
            .catch((error) => {
                alert_error(error);
            });
    };
    const fetchData_2 = (value) => {
        const apikey = Cookies.get('apikey');
        axios.post(value, {
            apikey: apikey
        })
            .then((response) => {
                if (window.location.href.includes('memory')) {
                    set_data_home(response.data);
                } else {
                    set_data_home(response.data.api_results);
                }
            })
            .catch((error) => {
                alert_error(error);
            });
    };

    const getLinkHref = (to) => {
        if (
            typeof to !== 'string' ||
            !to.includes('/next/') ||
            !isLocalHost(window.location.hostname)
        ) {
            return to;
        }

        const href = new URL(to, window.location.origin);
        href.protocol = 'http:';
        href.hostname = window.location.hostname;
        href.port = '3003';
        return href.toString();
    };

    return (
        <>
            <div className="max-w-5xl mx-auto">
                <div className="mt-2 mx-2 grid grid-cols-1">
                    <div className="bg-white p-3 rounded-md shadow-md md:col-span-2">
                        <div className="fixrow row text-center">

                            {
                                data_home && <>
                                    {data_home.links.map((link, index) => (
                                        <a
                                            style={{ textDecoration: 'none' }}
                                            href={getLinkHref(link.to)}
                                            className="flex break-inside bg-white text-black border-2 border-black rounded-3xl px-6 py-3 w-auto dark:bg-slate-800 dark:text-white"
                                            key={index}
                                        >
                                            <div className="m-auto">
                                                <div className="flex items-center justify-start flex-1 space-x-4">
                                                    <span className="font-medium px-2 text-lg">{link.text}</span>
                                                </div>
                                            </div>
                                        </a>
                                    ))}
                                </>
                            }
                            {
                                !data_home && (<p className="text-center text-red-500 text-lg">Bạn không phải quản lý app</p>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TaskList;
